import {InvestorCheckoutState} from 'Store/ibex/checkouts/sectionsStore';

export const checkoutStateIsVerificationOrAfter = (
  state: InvestorCheckoutState
) =>
  state === InvestorCheckoutState.INVESTOR_CONFIRMATION ||
  state === InvestorCheckoutState.TERMS_CONDITIONS ||
  state === InvestorCheckoutState.PAYMENT ||
  state === InvestorCheckoutState.CHECKOUT_COMPLETE ||
  state === InvestorCheckoutState.AGREEMENT_RESUBMISSION;
